import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "components/ui/accordion";
import { services } from "../content";
export default function ServiceAccordion({ full = false }) {
  const { hash } = useLocation();
  const linkedService =
    full && services.find((service) => `#${service.id}` === hash)?.id;
  const [openService, setOpenService] = useState(
    linkedService || "maintenance",
  );
  useEffect(() => {
    if (linkedService) setOpenService(linkedService);
  }, [linkedService]);
  return (
    <Accordion
      type="single"
      collapsible
      value={openService}
      onValueChange={setOpenService}
      className="site-service-accordion"
    >
      {services
        .slice(0, full ? 6 : 4)
        .map(({ id, title, icon: Icon, summary, description, details }) => (
          <AccordionItem value={id} id={id} key={id}>
            <AccordionTrigger variant="service">
              <span className="site-service-title">
                <Icon aria-hidden="true" />
                <span>{title}</span>
              </span>
            </AccordionTrigger>
            <AccordionContent>
              <div className="site-service-content">
                <p>{full ? description : summary}</p>
                {full ? (
                  <ul>
                    {details.map((detail) => (
                      <li key={detail}>{detail}</li>
                    ))}
                  </ul>
                ) : (
                  <Link to={`/services#${id}`} className="site-text-link">
                    Find out more
                    <ArrowUpRight aria-hidden="true" />
                  </Link>
                )}
              </div>
            </AccordionContent>
          </AccordionItem>
        ))}
    </Accordion>
  );
}
